import ProductWillBeAddedSoon from "../ProductWillBeAddedSoon";

const AudioPage = () => {
  return <ProductWillBeAddedSoon />;
};

export default AudioPage;
